import React, { useContext } from 'react';
import { shape, arrayOf, bool } from 'prop-types';
import {
  Button,
  Card,
  CardActions,
  CardBody,
  CardMedia,
  CardTitle,
  CardContent,
  Link
} from '@one-thd/sui-atomic-components';

import { extend } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { getBundleItemData } from '../../utils/product-utils';
import { BundleImage } from '../BundleImage';
import { BundleMiniPrice } from '../BundleMiniPrice';
import { MultiParentItemFulfillment } from './MultiParentItemFulfillment';

const MultiParentItem = ({ bundle, products, loading }) => {
  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext || {};

  if (!bundle || !products) return null;

  const {
    brand, image, label, url, buttonText
  } = getBundleItemData(bundle, products);

  return (
    <Card
      data-testid="multi-parent-item"
      CardContentProps={{
        className: 'sui-p-4 sui-flex sui-gap-4 sui-flex-col sm:sui-flex-row sm:sui-p-6 sm:sui-gap-6 sm:sui-items-center'
      }}
      key={bundle?.itemId}
    >
      <CardContent className="sm:sui-basis-2/4">
        <a
          href={url}
        >
          <div className="sui-block sm:sui-hidden">
            <CardMedia
              component={BundleImage}
              aspectRatio="3:2"
              src={image}
              alt={label}
            />
          </div>
          <div className="sui-hidden sm:sui-block">
            <CardMedia
              component={BundleImage}
              aspectRatio="1:1"
              src={image}
              alt={label}
            />
          </div>
        </a>
      </CardContent>
      <CardContent className="sui-flex sui-gap-4 sui-flex-col sm:sui-basis-2/4">
        <div className="sui-flex sui-flex-col sui-gap-2">
          {
            brand && <Link variant="body-base" href={url} underline="none">{brand}</Link>
          }
          <CardTitle
            header={label}
            headerWeight="bold"
            component="a"
            href={url}
            headerVariant={channel === 'mobile' ? 'h5' : 'h3'}
          />
        </div>
        <CardBody disableGrow>
          <BundleMiniPrice
            product={bundle}
            products={products}
            bundleId={bundle.itemId}
            hideUnitOfMeasure
            multiParent
            loading={loading}
          />
          <MultiParentItemFulfillment product={bundle} key={bundle?.itemId} />
        </CardBody>
        <CardActions>
          <Button
            variant="secondary"
            href={url}
          >{buttonText}
          </Button>
        </CardActions>
      </CardContent>
    </Card>
  );
};

MultiParentItem.propTypes = {
  bundle: shape({}).isRequired,
  products: arrayOf(shape({})).isRequired,
  loading: bool.isRequired
};

MultiParentItem.displayName = 'MultiParentItem';

MultiParentItem.dataModel = extend(
  BundleMiniPrice,
  MultiParentItemFulfillment
);

export { MultiParentItem };